import React from "react";
import withProviders from "../../hooks/withProviders";
import PersonalReminders from "../../features/personalreminders";
import { Main, ThemedIcon, PageSubHeader, FiltersAppliedWarningMessage } from "../../components/utilities";
import PageHeader, { PageHeaderTop } from "../../components/layout/PageHeader";
import { PageHeaderTitle } from "../../components/utilities/PageHeader";
import { IconButton } from "../../components";
import PersonalRemindersProvider, { usePersonalReminders } from "../../features/personalreminders/hooks/PersonalRemindersContext";
import PersonalRemindersFilterModal from "../../features/personalreminders/components/PersonalRemindersFilterModal";
import { CreateReminderModal } from "../../features/createreminderform";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Spinner } from "../../components/loaders";
import { FilterProvider, PersonalReminderDefaultFilters, useFilterContext } from "../../hooks/FilterContext";
import { useAuth } from "react-oidc-context";

export const PersonalRemindersPageWrapper = () => {

    const { user: { profile } } = useAuth();

    var defaultFilters = {
        ...PersonalReminderDefaultFilters,
        users :  [{ label: profile.name, value: profile.sub.replace(/-/g, "") }],
        userIds :  [profile.sub.replace(/-/g, "")]
    }

    return <React.Fragment>
        <FilterProvider defaultFilters={defaultFilters} filterStore={"personal-events"}>
            <PersonalRemindersProvider>
                <PersonalRemindersPage />
            </PersonalRemindersProvider>
        </FilterProvider>
    </React.Fragment>

};

const PersonalRemindersPage = () => {
    const [isFiltersShown, setIsFiltersShown] = React.useState(false);
    const [isCreateShown, setIsCreateShown] = React.useState(false);

    const { clearFilter, filter : { users, userIds }, isFiltersApplied, setFilter } = useFilterContext();
    
    return <React.Fragment>
        <PersonalRemindersFilterModal
            show={isFiltersShown}
            handleClose={() => setIsFiltersShown(false)}
        />
        <CreateReminderModal
            show={isCreateShown}
            onHide={() => setIsCreateShown(false)}
            showUserSelect
        />
        <PageHeader>
            <PageHeaderTop>
                <PageHeaderTitle>
                    <span>Events, Appointments, and Phone Calls</span>
                </PageHeaderTitle>
            </PageHeaderTop>
        </PageHeader>
        <Main className="d-flex flex-column">
            <PageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        {isFiltersApplied && (
                            <React.Fragment>
                                <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                <FiltersAppliedWarningMessage className="ms-2 text-muted">
                                    Warning - Filters are currently being applied to your results.
                                    <br />
                                    <a href="#" onClick={clearFilter}>Click here</a> to clear your filters.
                                </FiltersAppliedWarningMessage>
                            </React.Fragment>
                        )}
                    </div>
                    <div className="d-flex flex-fill justify-content-end align-items-center gap-2">
                        <IconButton icon={['fas', 'filter']} onClick={() => setIsFiltersShown(true)}>
                            Filter Events
                        </IconButton>
                        <IconButton icon={"fa-plus"} variant="success" onClick={() => setIsCreateShown(true)}>
                            Create New Event
                        </IconButton>
                    </div>
                </div>
            </PageSubHeader>
            <section className="px-4 my-3 h-100">
                <PersonalReminders />
            </section>
        </Main>
    </React.Fragment>
};

export default withProviders([PersonalRemindersProvider])(PersonalRemindersPage);